<template>
  <div class="journey-single-day advanced-editor">
    <div class="journey-day-header">
      <h3>
        <span class="fs-title-14">Day</span>
        <span class="fs-title-18" v-text="dayIndex"></span>
      </h3>
    </div>
    <div class="journey-day">
      <div class="journey-flex">
        <div class="journey-row" v-for="(item, index) in analyzedJourneyDayData" :key="index">
          <div class="journey-time">
            <div class="route-time" v-if="item.type === 'route'">
              {{durationFromTimeStamps(item.endTimestamp - item.startTimestamp)}} 分鐘
            </div>
          </div>

          <div class="journey-icon" :class="{'operation':item.type === 'operation'}">
            <div class="icon-line up">
            </div>
            <div class="icon-line down">
            </div>

            <div class="icon-milestone" v-if="item.type === 'milestone'">
              <div :class="parseIconClass(item.detail) + ' icon-milestone-content'">
                <img class="mountain" title="三角點" :src="imageSrc.svgMountains" alt="icon"/>
                <img class="parking" title="停車場" :src="imageSrc.svgParking" alt="icon"/>
                <img class="house" title="山屋" :src="imageSrc.svgHouse" alt="icon"/>
                <img class="toilet" title="生態廁所" :src="imageSrc.svgToilet" alt="icon"/>
                <img class="camp" title="可紮營" :src="imageSrc.svgCamp" alt="icon" />
                <img class="entrance" title="入山口" :src="imageSrc.svgWalk" alt="icon"/>
                <img class="water" title="取水點" :src="imageSrc.svgWater" alt="icon"/>
                <img class="wifi" title="訊號點" :src="imageSrc.svgWifi" alt="icon"/>
              </div>
            </div>

            <div class="icon-milestone" v-if="item.type === 'operation'">
              <div class="icon-none icon-milestone-content"></div>
            </div>
          </div>

          <div class="journey-detail" :class="{'operation':item.type === 'operation'}">
            <div class="milestone-detail" v-if="item.type === 'milestone'">
              <p class="milestone-name">
                <span>{{item.detail.name}}</span>
                <span class="milestone-height">{{item.detail.height + 'm'}}</span>
              </p>
              <b-dropdown variant="link" toggle-class="milestone-opt text-decoration-none" right no-caret v-if="breakpointIndex > 0 && ( index === breakpointIndex - 1 || index === breakpointIndex + 1 ) ">
                <template #button-content>
                  <span>...</span>
                </template>
                <b-dropdown-item class="text-center" @click="removeMilestone(index)">移除里程碑</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="route-detail" v-if="item.type === 'route'">
              <p class="route-name">
                <span class="route-distance" :title="item.detail.distance + '公尺'"><span class="t-bold">{{(item.detail.distance / 1000.0).toFixed(1)}}</span>km</span>

                <span>
                <template v-if="item.elevation">
                  <span class="t-bold" v-show="item.elevation.heightDiff >= 0"><img style="height: 1em;" :src="imageSrc.svgClimbUp" alt="icon"/></span>
                  <span class="t-bold" v-show="item.elevation.heightDiff < 0"><img style="height: 1em;" :src="imageSrc.svgClimbDown" alt="icon"/></span>
                  <span class="t-bold">{{Math.abs(item.elevation.heightDiff)}}</span>m
                </template>
              </span>
              </p>
            </div>

            <div class="milestone-detail" v-if="item.type === 'break'">
              <p class="milestone-name">休息 {{durationFromTimeStamps(item.duration)}} 分鐘</p>
            </div>

            <div class="operation-detail" v-if="item.type === 'operation'" ref="operationDetail">
              <b-form-select
                  v-model="selectedRoute"
                  :options="linkedRouteOptions(item)"
                  @input="onMilestoneSelected(item, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapActions, mapGetters, mapState} from "vuex";

import svgDirectionsWalk from "@/assets/images/milestone-icon/directions_walk.svg"
import svgRest from "@/assets/images/milestone-icon/new-rest.svg"
import svgDistance from "@/assets/images/milestone-icon/distance.svg"
import svgClimbUp from "@/assets/images/milestone-icon/climb-up.svg"
import svgClimbDown from "@/assets/images/milestone-icon/climb-down.svg"
import svgMountains from "@/assets/images/milestone-icon/mountains.svg"
import svgParking from "@/assets/images/milestone-icon/parking.svg"
import svgHouse from "@/assets/images/milestone-icon/house.svg"
import svgToilet from "@/assets/images/milestone-icon/toilet.svg"
import svgCamp from "@/assets/images/milestone-icon/camp.svg"
import svgWalk from "@/assets/images/milestone-icon/walk.svg"
import svgWater from "@/assets/images/milestone-icon/water.svg"
import svgWifi from "@/assets/images/milestone-icon/wifi.svg"

export default {
  name: 'AdvancedEditorJourneyDay',
  data() {
    return {
      readInfoBusyName: 'ReadingAdvancedEditorJourneyDay',

      selectedRoute: null,

      breakpointIndex: -1,

      imageSrc: {
        svgDirectionsWalk: svgDirectionsWalk,
        svgRest: svgRest,
        svgDistance: svgDistance,
        svgClimbUp: svgClimbUp,
        svgClimbDown: svgClimbDown,

        svgMountains: svgMountains,
        svgParking: svgParking,
        svgHouse: svgHouse,
        svgToilet: svgToilet,
        svgCamp: svgCamp,
        svgWalk: svgWalk,
        svgWater: svgWater,
        svgWifi: svgWifi,
      },
    }
  },
  props: {
    journeyDayData: {
      type: Array,
      required: true,
    },
    dayIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('journey', ['climbRateArray']),
    ...mapGetters('journey', ['journeyData', 'compiledSplitIndexs', 'compiledJourneyArray', 'isComplete']),

    analyzedJourneyDayData() {
      if (!Array.isArray(this.journeyDayData)) return [];

      return this.journeyDayData.map((item, index, array) => {
        // 只處理 route
        if (item.type !== 'route') {
          return item;
        }

        // 往前找 milestone
        let prevMilestone = null;
        for (let i = index - 1; i >= 0; i--) {
          if (array[i].type === 'milestone') {
            prevMilestone = array[i];
            break;
          }
        }

        // 往後找 milestone
        let nextMilestone = null;
        for (let i = index + 1; i < array.length; i++) {
          if (array[i].type === 'milestone') {
            nextMilestone = array[i];
            break;
          }
        }

        // 找不到前後 milestone → 不處理，原樣回傳
        if (!prevMilestone || !nextMilestone) {
          return item;
        }

        const startHeight = prevMilestone.detail?.height;
        const endHeight = nextMilestone.detail?.height;

        if (
            typeof startHeight !== 'number' ||
            typeof endHeight !== 'number'
        ) {
          return item;
        }

        const heightDiff = endHeight - startHeight;

        let elevationType = 'flat';
        if (heightDiff > 0) elevationType = 'up';
        else if (heightDiff < 0) elevationType = 'down';

        // 回傳「新物件」，不污染原資料
        return {
          ...item,
          elevation: {
            startHeight,
            endHeight,
            heightDiff,
            elevationType,
          },
        };
      });
    },
  },
  watch: {
    journeyDayData: {
      immediate: true,
      handler(data) {
        this.clearLinkedRoutes();

        let hasRecordedFirst = false

        data.forEach((item, index) => {
          if (item.type === 'operation') {
            this.breakpointIndex = index;
            this.fetchOperationRoutes(item, hasRecordedFirst);

            if (!hasRecordedFirst) {
              hasRecordedFirst = true
            }
          }
        });
      },
    },
  },
  async created() {
  },
  async mounted() {
    // this.refresh();
    if (this.breakpointIndex > 0) {
      this.setOperationCenter();
    }
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions(['appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    ...mapActions('journey', ['setClimbRateAtIndex', 'insertJourneyItem', 'removeJourneyPoint', 'setLinkedRoutes', 'clearLinkedRoutes']),

    // refresh() {
    // },
    async fetchOperationRoutes(operation, skipVuex = false) {
      if (!operation.currSerial) return [];

      await this.appendComponentBusy(this.readInfoBusyName);
      try {
        const milestoneSerial = operation.currSerial;
        const routes = await this.$store.dispatch(
            'api/postPathQueryLinkedRoutesPromise',
            milestoneSerial
        );
        // console.log(routes);


        // 需要被移到最後的 routes
        const tailRoutes = routes.filter(
            r => r.targetMilestone?.serial === operation.prevSerial
        );

        // 其他正常順序的 routes
        const normalRoutes = routes.filter(
            r => r.targetMilestone?.serial !== operation.prevSerial
        );

        // 從 normalRoutes 再拆一層
        const firstRoutes = [];
        const headRoutes = normalRoutes.filter(
            r => r.targetMilestone?.serial === operation.nextSerial
        );
        if (headRoutes.length > 0) {
          for (const r of headRoutes) {
            const tempR = { ... r};
            // tempR.targetMilestone = { ... r.targetMilestone}
            // tempR.targetMilestone.name += "(將路線相連)";
            tempR.connect = true;  // 多加一個flag用來確認要路線相連
            firstRoutes.push(tempR);

            const tempR2 = { ... r};
            // tempR2.targetMilestone = { ... r.targetMilestone}
            // tempR2.targetMilestone.name += "(不將路線相連)";
            tempR2.connect = false;  // 多加一個flag用來確認要路線相連
            firstRoutes.push(tempR2);
          }
        }

        const middleRoutes = normalRoutes.filter(
            r => r.targetMilestone?.serial !== operation.nextSerial
        );

        // 最終排序
        // const sortedRoutes = normalRoutes.concat(tailRoutes);
        const sortedRoutes = [
          ...firstRoutes,   // 第一優先
          ...middleRoutes, // 一般
          ...tailRoutes    // 最後
        ];

        // 重要：只有第一個 operation 才寫入 Vuex
        if (!skipVuex) {
          this.setLinkedRoutes(sortedRoutes);
        }

        this.$set(operation, 'linkedRoutes', sortedRoutes);
      } catch (err) {
        console.error('[fetchLinkedRoutesByMilestone] error:', err);
        this.appendErrorMsg(err)
      } finally {
        await this.clearComponentBusy(this.readInfoBusyName);
      }
    },
    linkedRouteOptions(operation) {
      if (!Array.isArray(operation.linkedRoutes)) return [];

      return [
        {
          value: null,
          text: '請選擇里程點',
          disabled: true, // 可選：避免被選回去
        },
        ...operation.linkedRoutes.map((route, index) => {
          let t = route.targetMilestone?.name || '未命名里程點';
          if (route.ps.trim().length > 0) {
            t += `(${route.ps.trim()})`;
          }
          if (route.targetMilestone.serial === operation.nextSerial) {
            if (route.connect) {
              t += "(將路線相連)";
            } else {
              t += "(不將路線相連)";
            }
          }
          return {
            value: index,
            text: t,
          }
        }),
      ];
    },
    onMilestoneSelected(operation, idx) {
      console.log(operation)
      console.log('選到的路線index為:', this.selectedRoute);
      const splitIndex = this.dayIndex - 2
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx)
      const nextIndex = index + 1

      const selectedRouteObj = operation.linkedRoutes[this.selectedRoute];
      const { targetMilestone, ...routeData } = selectedRouteObj;
      const newRoute = {
        detailObject: routeData,
        duration: operation.currSerial === routeData.startMilestone ? routeData.consuming : routeData.returnConsuming,
        isRestPoint: false,
        routeDirection: operation.currSerial === routeData.startMilestone ? 0 : 1,
        serial: routeData.serial,
        type: 'route',
      };
      const newMilestone = {
        detailObject: targetMilestone,
        duration: 0,
        isRestPoint: false,
        routeDirection: 0,
        serial: targetMilestone.serial,
        type: 'milestone',
      };

      if(operation.nextSerial === selectedRouteObj.targetMilestone.serial && selectedRouteObj.connect) {
        this.insertJourneyItem({index: index, item: newRoute});
        this.$emit('routeConnected');
      } else {
        this.insertJourneyItem({index: index, item: newRoute});
        this.insertJourneyItem({index: nextIndex, item: newMilestone});
      }
      this.$emit('updated');
      this.selectedRoute = null;

      this.$gtag.event('CustomClick', {
        event_label: "journeyAdvancedEditAppendMilestone",
      });
    },
    timeStampToTime(timestamp) {
      if (!timestamp || typeof timestamp !== 'number' || isNaN(timestamp)) {
        return "--:--"
      }

      const date = new Date(timestamp)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    durationFromTimeStamps(t) {
      return parseInt(moment.duration(t).asMinutes());
    },
    parseIconClass(m) {
      if (m.triangle) {
        return 'icon-mountain';
      } else if (m.parking) {
        return 'icon-parking';
      } else if (m.entrance) {
        return 'icon-entrance';
      } else if (m.house) {
        return 'icon-house';
      } else if (m.waterspot === 1) {
        return 'icon-water';
      } else if (m.campable) {
        return 'icon-camp';
        // } else if (m.signal) {
        //   return 'icon-wifi';
      } else if (m.toilet) {
        return 'icon-toilet';
      }
      return 'icon-none';
    },
    mergeTimeToTimestamp(baseTimestamp, timeStr) {
      const [hour, minute] = timeStr.split(':').map(Number);
      return moment(baseTimestamp)
          .hour(hour)
          .minute(minute)
          .second(0)
          .millisecond(0)
          .valueOf();
    },
    removeMilestone(idx) {
      const splitIndex = this.dayIndex - 2;
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx);
      if(idx > this.breakpointIndex) {
        this.removeJourneyPoint(index - 1);
      } else {
        this.removeJourneyPoint(index);
      }
      this.$emit('updated');
      this.setOperationCenter();

      if (idx < this.breakpointIndex) {
        this.$gtag.event('CustomClick', {
          event_label: "journeyAdvancedEditRemovePreviousMilestone",
        });
      } else {
        this.$gtag.event('CustomClick', {
          event_label: "journeyAdvancedEditRemoveNextMilestone",
        });
      }
      
    },
    startTimeChanged(evt) {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditDepartTime",
      });
      this.$emit('start-time-changed', evt.target.value);
    },
    setOperationCenter() {
      setTimeout(() => {
        // console.log(this.$refs['operationDetail']);
        this.$refs['operationDetail'][0].scrollIntoView({block: 'center'});
      }, 100);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.journey-single-day.advanced-editor {
  .journey-day-header {
    display: flex;
    justify-content: center;
    h3 {
      display: flex;
      align-items: center;
      gap: .5rem;
      color: $color-white;
      background: $color-black;
      border-radius: 100px;
      padding: .125rem .5rem;
    }
  }
}

.journey-day {
  --icon-line-color: #DBDBDB;
  padding: 1.25rem 0;
  background-color: #fff;
}

.t-bold {
  font-weight: 1000;
}

.journey-head {
}

.day-features {
  display: flex;
  justify-content: flex-start;
  /* padding: 0 20px; */
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: .5em;
  overflow: hidden;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.day-feature {
  flex: 0 0 auto;
  text-align: center;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.day-feature-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.day-feature-img>img {
  /* height: 28px; */
  display: block;
  transform: scale(.8);
  margin-left: auto;
  margin-right: auto;
  /* margin: 0 auto 4px; */
}

.day-feature-img>span {
  font-size: .6rem;
}

.day-feature>p {
  font-size: .7rem;
  margin-bottom: 0;
}

.day-feature .big-text {
  font-size: 1.1rem;
  font-weight: 600;
}

.day-start-time-select {
  margin-bottom: 1.5em;
  font-size: .8rem;
  //color: #ccc;
}

.day-start-time-select>select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='12' width='12' xmlns='http://www.w3.org/2000/svg'><polygon points='0,3 12,3 6,9'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.4em center;
  background-size: 0.7em;
  border-radius: 100px;
  border: 1px solid $color-black;
  padding: .25rem 1rem .25rem .5rem;
  margin-left: .75rem;
}

.journey-flex {
  display: flex;
  flex-wrap: wrap;
  padding-top: 14px;
  /* flex-direction: column; */
}

.journey-head+.journey-flex {
  padding-top: 0;
}

.journey-row {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}

/*
.journey-row:first-child a.milestone-opt, .journey-row:last-child a.milestone-opt {
  display: none;
}
*/

.journey-time {
  flex: 0 0 60px;
  text-align: right;
}

.milestone-time {
  font-size: .9em;
}

.route-time {
  font-size: .9em;
  opacity: .25;
}

.journey-icon {
  flex: 0 0 50px;
  width: 50px;
  min-height: 36px;
  position: relative;
  place-self: stretch;
  &.operation {
    min-height: 108px;
    .icon-milestone {
      top: calc(50% - 6px);
    }

    .icon-line.down {
      background-color: transparent;
      background-image: repeating-linear-gradient(
              to bottom,
              var(--icon-line-color) 0,
              var(--icon-line-color) 8px,
              transparent 8px,
              transparent 14px
      );
    }

    .icon-line.up {
      height: calc(50% - 6px);
    }

    .icon-line.down {
      height: calc(50% + 6px);
    }
  }
}

.icon-line {
  position: absolute;
  width: 4px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: var(--icon-line-color);
}

.icon-line.up {
  top: 0;
  height: 12px;
}

.icon-line.down {
  bottom: 0;
  height: calc(100% - 12px);
}

.journey-row:first-child .icon-line.up {
  display: none;
}

.journey-row:last-child .icon-line.down {
  display: none;
}

.icon-milestone {
  position: absolute;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border: solid 4px var(--icon-line-color);
  /* border: none; */
  top: 12px;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.icon-milestone-content {
  position: absolute;
  width: 24px;
  height: 24px;
  /* background-color: #E5DC81; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-milestone-content.icon-none {
  display: none;
}

.icon-milestone-content>img {
  display: none;
  width: 100%;
}

.icon-milestone-content.icon-mountain>img.mountain {
  display: block;
}

.icon-milestone-content.icon-parking>img.parking {
  display: block;
}

.icon-milestone-content.icon-entrance>img.entrance {
  display: block;
}

.icon-milestone-content.icon-water>img.water {
  display: block;
}

.icon-milestone-content.icon-camp>img.camp {
  display: block;
}

.icon-milestone-content.icon-wifi>img.wifi {
  display: block;
}

.icon-milestone-content.icon-toilet>img.toilet {
  display: block;
}

.icon-milestone-content.icon-house>img.house {
  display: block;
}

.icon-milestone-content.icon-house>img.house {
  display: block;
}

.journey-detail {
  flex: 10 1;
  &.operation {
    display: flex;
    align-items: center;
    height: 100%;
    .operation-detail {
      position: relative;
      top: -6px;
      width: 100%;
      select.custom-select {
        position: relative;
        background-color: $color-white;
        width: 100%;
        height: auto;
        font-size: .875rem;
        border-radius: 100px;
        border: 1px solid $color-black;
        padding: 1.25rem 1rem 1.25rem .75rem;
        text-decoration: none;
        &:after {
          position: absolute;
          top: 50%;
          right: 16px;
          content: '';
          color: $color-black-900;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 5px 5px 0 5px;
          border-color: $color-black-900 transparent transparent transparent;
          transform: translate(-10px, -50%);
        }
      }
    }
  }
}

.milestone-detail {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.milestone-name {
  display: flex;
  align-items: center;
  margin: 0;
  font-size: .9em;
  flex: 1 1;
  padding-right: .5em;
}

.milestone-height {
  font-size: .8em;
  padding-left: .5em;
}

.milestone-weather {
  flex: 0 0 110px;
}

.route-detail {
}

.route-name {
  margin: 0;
  font-size: .9em;
  opacity: .25;
}

.route-distance {
  padding-right: 1em;
}

.desc {
  color: $color-bk-tp-50;
}

@media (min-width: 992px) {
  .journey-day {
    padding: 1.25rem .5rem;
  }

  .day-features::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .day-features::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .day-features::-webkit-scrollbar-thumb {
    background: #ddd;
  }

  .day-features::-webkit-scrollbar-thumb:hover {
    background: #888;
  }
}
</style>

<style lang="scss">
.journey-single-day {
  .milestone-opt.btn {
    display: flex;
    align-items: center;
    font-size: .9em;
    line-height: 1;
    letter-spacing: 1px;
    padding: 0 10px 10px;
    font-weight: 1000;
    color: #000;
    &:hover {
      color: #000;
    }
  }
}
</style>
